/**
 * Thème global de l'application
 * Définit les couleurs et styles principaux à utiliser dans tous les composants
 */

// Couleurs principales
export const colors = {
  primary: "#57A863",
  secondary: "#4C9958",
  primaryLight: "rgba(87, 168, 99, 0.1)",
  primaryLighter: "rgba(87, 168, 99, 0.05)",
  primaryDark: "#3F7E48",
  danger: "#d33",
  warning: "#F5A623",
  info: "#2196F3",
  success: "#57A863",
  gray: "#8C8C8C",
  lightGray: "#F5F5F5",
  white: "#FFFFFF",
  black: "#000000",
  text: "#333333",
};

// Configuration du thème pour Ant Design
export const antTheme = {
  token: {
    colorPrimary: colors.primary,
    colorLink: colors.primary,
    colorSuccess: colors.success,
    colorWarning: colors.warning,
    colorError: colors.danger,
    colorInfo: colors.info,
    borderRadius: 4,
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    Button: {
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primaryDark,
    },
    Table: {
      headerBg: colors.primaryLight,
      headerColor: colors.text,
    },
  },
};

// Styles globaux CSS pour surcharger les styles Ant Design
export const globalStyles = `
  /* Styles de pagination */
  .ant-pagination .ant-pagination-item-active {
    border-color: ${colors.primary};
  }
  .ant-pagination .ant-pagination-item-active a {
    color: ${colors.primary};
  }
  
  /* Styles de tableau */
  .custom-table .ant-table-thead > tr > th {
    background-color: ${colors.primaryLight};
  }
  .custom-table .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${colors.primary};
    border-color: ${colors.primary};
  }
  .custom-table .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: ${colors.primaryLighter};
  }
  .custom-table .ant-table-column-sorter-up.active, 
  .custom-table .ant-table-column-sorter-down.active {
    color: ${colors.primary};
  }
  
  /* Styles de formulaire */
  .ant-form-item-has-success .ant-input,
  .ant-form-item-has-success .ant-input-affix-wrapper {
    border-color: ${colors.primary};
  }
  .ant-input:hover {
    border-color: ${colors.primary};
  }
  .ant-input:focus, 
  .ant-input-focused {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 2px ${colors.primaryLighter};
  }
  
  /* Styles des tags */
  .ant-tag-green {
    color: ${colors.primary};
    background: ${colors.primaryLighter};
    border-color: ${colors.primary};
  }
  
  /* Styles des sélecteurs */
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${colors.primary};
  }
  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active {
    border-color: ${colors.primary} !important;
    box-shadow: 0 0 0 2px ${colors.primaryLighter} !important;
  }
  
  /* Styles des modals */
  .ant-modal-title {
    color: ${colors.text};
  }
  .ant-modal-close:hover {
    color: ${colors.primary};
  }
`;

// Utilitaires de style pour tailwind/className
export const tailwindClasses = {
  primaryButton: "bg-[#57A863] hover:bg-[#3F7E48] border-[#57A863] text-white",
  outlineButton:
    "border-[#57A863] text-[#57A863] hover:bg-[#57A863] hover:text-white hover:border-[#57A863]",
  cardWithShadow: "bg-white rounded-lg shadow-md p-6",
  sectionTitle: "text-xl font-semibold text-gray-800",
  sectionTitleWithIcon:
    "text-xl font-semibold text-gray-800 flex items-center before:content-['•'] before:text-[#57A863] before:mr-2 before:text-2xl",
  tableContainer: "overflow-x-auto rounded-lg",
  formLabel: "text-gray-700 font-medium",
  alert: "rounded-md p-4 mb-4",
  alertSuccess:
    "rounded-md p-4 mb-4 bg-[#57A863]/10 text-[#3F7E48] border border-[#57A863]/20",
  alertError:
    "rounded-md p-4 mb-4 bg-red-50 text-red-800 border border-red-100",
  tag: "px-2 py-1 rounded-full text-xs font-medium bg-[#57A863]/10 text-[#57A863]",
};

export default { colors, antTheme, globalStyles, tailwindClasses };
